<div class="flex items-center justify-center desktop-page-selector">
   <nav class="flex items-center gap-3">

        @for (page of navItems; let index = $index; track page.route) {
            <a  
                class="page-selector-item text-white 
                hover:bg-[#08389c] dark:hover:bg-[#1a305f]"
                
                routerLinkActive="active"
                [routerLink]="page.route"
                [routerLinkActiveOptions]="{ exact: false }"
            >
                {{ page.label }}
            </a>
        }

    </nav>

</div>


<app-sidebar 
    class="mobile-page-selector"
></app-sidebar>